import type { Reflect } from "@workcanvas/reflect/client";
import { useBoardIntegrations } from "frontend/hooks/use-board-integrations";
import { useAtomValue } from "jotai";
import { useCallback } from "react";
import type { M } from "shared/datamodel/mutators";
import { documentIdAtom } from "state-atoms/stage-atoms";
import { useRawCanvasMetadata } from "subscriptions";

export const useColumnConfiguration = ({ reflect }: { reflect?: Reflect<M> | null }) => {
  const { documentId } = useAtomValue(documentIdAtom);
  const { boardIntegrations } = useBoardIntegrations(documentId);
  const metadata = useRawCanvasMetadata(reflect);

  // given integration-id, find a mapping to the monday-board in reflect.
  return useCallback(
    (integrationId: string) => {
      const boardId = boardIntegrations?.find(({ id }) => id == integrationId)?.configuration.boardId;
      return metadata?.find(([k, _]) => k == `cMetadata-${boardId}`)?.[1]?.boardColumnsMapping;
    },
    [boardIntegrations, metadata]
  );
};
